/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
// Library Imports
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import withDefaultPrevented from '../../../../../../withDefaultPrevented';
import Link from '../../../../../OC/oc-link';
import { PrefixWithLocale } from '../../../../../Utilities';
import { connectLocation } from '../../../../../location/LocationConnectors';

const Container = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  line-height: 16px;
  padding: 12px 20px;
  background: #000000;
  color: #ffffff;

  .banner-text {
    display: inline-flex;
    justify-content: flex-start;
    line-height: 18px;
    position: relative;

    &:before {
      content: '\\f071';
      font-family: 'fontawesome';
      margin-right: 12px;
    }

    a {
      color: inherit;
      font-weight: 700;

      &:hover {
        cursor: pointer;
      }
    }
  }
`;

const Banner = ({ zip, openLocationModal, t, locale }) => (
  <Container>
    <div className="banner-text">
      <div className="message">
        {`${t('pdp.product_not_available')} (${zip}) `}
        <Link onClick={withDefaultPrevented(openLocationModal)}>{t('pdp.change_location')}</Link>
        {` ${t('pdp.or')} `}
        <Link href={PrefixWithLocale('/roofing/components/products', locale.code)}>{t('pdp.browse_products')}</Link>
      </div>
    </div>
  </Container>
);

Banner.propTypes = {
  zip: PropTypes.string.isRequired,
  openLocationModal: PropTypes.func.isRequired,
};

const ConnectedBanner = connectLocation(Banner);

const UnavailableProductsBannerWithStore = () => {
  const store = ReactOnRails.getStore('Store');

  return (
    <Provider store={store}>
      <ConnectedBanner />
    </Provider>
  );
};

export default UnavailableProductsBannerWithStore;
